import { lazy } from 'react';

const NoticeBoardRoutes = [
  {
    path: 'content/notice-board',
    component: lazy(() => import('views/notice-board')),
  },
];

export default NoticeBoardRoutes;
